import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
interface LoadingScreenProps {
  onComplete: () => void;
}
export function LoadingScreen({
  onComplete
}: LoadingScreenProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onComplete();
    }, 5000); // 5 seconds
    return () => clearTimeout(timer);
  }, [onComplete]);
  return <div className="relative w-full h-screen bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center overflow-hidden" data-id="element-353">
      {/* Animated background */}
      <div className="absolute inset-0 opacity-20" data-id="element-354">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-cyan-500/20 rounded-full blur-3xl animate-pulse" data-id="element-355" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl animate-pulse delay-1000" data-id="element-356" />
      </div>

      <div className="relative z-10 max-w-4xl px-8" data-id="element-357">
        {/* Loading spinner */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="flex justify-center mb-8" data-id="element-358">
          <div className="relative w-16 h-16" data-id="element-359">
            <div className="absolute inset-0 border-4 border-cyan-500/30 rounded-full" data-id="element-360" />
            <motion.div animate={{
            rotate: 360
          }} transition={{
            duration: 1,
            repeat: Infinity,
            ease: 'linear'
          }} className="absolute inset-0 border-4 border-transparent border-t-cyan-500 rounded-full" data-id="element-361" />
          </div>
        </motion.div>

        {/* Loading text */}
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="text-center text-white text-lg mb-12" data-id="element-362">
          Initializing Virtual Experience...
        </motion.p>

        {/* Disclaimer */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5
      }} className="bg-slate-800/50 backdrop-blur-xl rounded-2xl p-8 border border-white/10" data-id="element-363">
          <h2 className="text-2xl font-bold text-white text-center mb-6" data-id="element-364">
            Artistic Representation Disclaimer
          </h2>

          <div className="space-y-4 text-white/80 text-sm leading-relaxed" data-id="element-365">
            <p data-id="element-366">
              Please be advised that all renderings, floor plans, virtual tours,
              and other visual representations displayed within this software
              are artist's conceptions and are for illustrative purposes only.
              They are not intended to be an exact depiction of the buildings,
              landscaping, or final product.
            </p>

            <p data-id="element-367">
              Features, specifications, materials, finishes, colors, and
              dimensions are approximate and are subject to change without
              notice. The actual view from any unit may vary. Furnishings,
              décor, and appliances are shown for demonstration purposes only
              and are not included unless specified in the purchase agreement.
            </p>

            <p data-id="element-368">
              Users should rely on the information contained in the official
              sales and legal documents for accurate details.
            </p>

            <p className="text-center text-white/50 text-xs mt-6" data-id="element-369">
              2025 ResVR. All Rights Reserved.
            </p>
          </div>
        </motion.div>
      </div>
    </div>;
}